import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/company-banner.png';
import _imports_1 from './img/qz.png';
import _imports_2 from './img/left.png';
import _imports_3 from './img/right.png';
import _imports_4 from './img/yh.png';
import _imports_5 from './img/icon_sm.png';
import _imports_6 from './img/icon_yj.png';
import _imports_7 from './img/icon_jzg.png';
import _imports_8 from './img/zsbf.png';
import _imports_9 from './img/cpzx.png';
import _imports_10 from './img/sh.png';
const _hoisted_1 = {
  class: "about-us"
};
const _hoisted_2 = {
  class: "about-us-head"
};
const _hoisted_3 = {
  class: "banner-describe"
};
const _hoisted_4 = {
  class: "banner-title1"
};
const _hoisted_5 = {
  class: "banner-title2"
};
const _hoisted_6 = {
  class: "banner-title3"
};
const _hoisted_7 = {
  class: "company-profile"
};
const _hoisted_8 = {
  class: "company-profile-title"
};
const _hoisted_9 = {
  class: "company-profile-title2"
};
const _hoisted_10 = {
  class: "company-profile-describe"
};
const _hoisted_11 = {
  class: "company-profile-content"
};
const _hoisted_12 = {
  class: "company-profile-text",
  style: {
    "margin-top": "7px"
  }
};
const _hoisted_13 = {
  class: "company-profile-text"
};
const _hoisted_14 = {
  class: "company-profile-text"
};
const _hoisted_15 = {
  class: "data-statistics"
};
const _hoisted_16 = {
  class: "data-statistics-content"
};
const _hoisted_17 = {
  class: "data-statistics-item"
};
const _hoisted_18 = {
  class: "data-statistics-title2"
};
const _hoisted_19 = {
  class: "data-statistics-item"
};
const _hoisted_20 = {
  class: "data-statistics-title2"
};
const _hoisted_21 = {
  class: "data-statistics-item"
};
const _hoisted_22 = {
  class: "data-statistics-title2"
};
const _hoisted_23 = {
  class: "data-statistics-item"
};
const _hoisted_24 = {
  class: "data-statistics-title2"
};
const _hoisted_25 = {
  class: "data-statistics-item"
};
const _hoisted_26 = {
  class: "data-statistics-title2"
};
const _hoisted_27 = {
  class: "data-statistics-item"
};
const _hoisted_28 = {
  class: "data-statistics-title2"
};
const _hoisted_29 = {
  class: "corporate-culture"
};
const _hoisted_30 = {
  class: "corporate-culture-content"
};
const _hoisted_31 = {
  class: "corporate-culture-title"
};
const _hoisted_32 = {
  class: "corporate-culture-title2"
};
const _hoisted_33 = {
  class: "corporate-culture-card"
};
const _hoisted_34 = {
  class: "corporate-culture-item"
};
const _hoisted_35 = {
  class: "card-content"
};
const _hoisted_36 = {
  class: "card-left"
};
const _hoisted_37 = {
  class: "card-left-title"
};
const _hoisted_38 = {
  class: "card-left-title2"
};
const _hoisted_39 = {
  class: "corporate-culture-item"
};
const _hoisted_40 = {
  class: "card-content"
};
const _hoisted_41 = {
  class: "card-left"
};
const _hoisted_42 = {
  class: "card-left-title"
};
const _hoisted_43 = {
  class: "card-left-title2"
};
const _hoisted_44 = {
  class: "corporate-culture-item"
};
const _hoisted_45 = {
  class: "card-content"
};
const _hoisted_46 = {
  class: "card-left"
};
const _hoisted_47 = {
  class: "card-left-title"
};
const _hoisted_48 = {
  class: "card-left-title2"
};
const _hoisted_49 = {
  class: "corporate-honors"
};
const _hoisted_50 = {
  class: "corporate-honors-content"
};
const _hoisted_51 = {
  class: "corporate-honors-title"
};
const _hoisted_52 = {
  class: "corporate-honors-title2"
};
const _hoisted_53 = {
  class: "contact-us"
};
const _hoisted_54 = {
  class: "contact-us-content"
};
const _hoisted_55 = {
  class: "contact-us-title"
};
const _hoisted_56 = {
  class: "contact-us-title2"
};
const _hoisted_57 = {
  class: "contact-us-card"
};
const _hoisted_58 = {
  class: "contact-us-item"
};
const _hoisted_59 = {
  class: "contac-item-top"
};
const _hoisted_60 = {
  class: "contac-item-title"
};
const _hoisted_61 = {
  class: "contac-item-title2"
};
const _hoisted_62 = {
  class: "contac-item-title3"
};
const _hoisted_63 = {
  class: "contact-us-item"
};
const _hoisted_64 = {
  class: "contac-item-top"
};
const _hoisted_65 = {
  class: "contac-item-title"
};
const _hoisted_66 = {
  class: "contac-item-title2"
};
const _hoisted_67 = {
  class: "contac-item-title3"
};
import AMapLoader from '@amap/amap-jsapi-loader';
import Swiper from 'swiper';
import SwiperCore, { Autoplay, Navigation } from 'swiper/core';
import 'swiper/swiper-bundle.css';
import { nextTick, onMounted, onUnmounted, reactive } from 'vue';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    SwiperCore.use([Autoplay]);
    SwiperCore.use([Navigation]);
    const route = useRoute();
    const state = reactive({
      activeIndex: 0
    });
    onMounted(() => {
      nextTick(() => {
        initSwiper();
        scrollToClass();
        initMap();
      });
    });
    let map,
      marker = null;
    onUnmounted(() => {
      var _map;
      (_map = map) === null || _map === void 0 || _map.destroy();
    });
    const initMap = () => {
      AMapLoader.load({
        key: window.Config.aMapKey,
        version: '2.0',
        plugins: [] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then(AMap => {
        map = new AMap.Map('contact-map', {
          // 设置地图容器id
          viewMode: '3D',
          zoom: 17,
          center: new AMap.LngLat(...window.Config.mapCenter) // 初始化地图中心点位置
        });
        addMarker();
      }).catch(e => {
        console.log(e);
      });
    };
    const addMarker = () => {
      const markContent = `
    <div class="custom-marker">
      <img class="mark-icon" src="//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png"/>
      <div class="custom-txt">孵化园9号楼F座2楼5号</div>
    </div>
  `;
      marker = new AMap.Marker({
        position: new AMap.LngLat(...window.Config.mapCenter),
        content: markContent,
        offset: new AMap.Pixel(-13, -30)
      });
      map.add(marker);
    };
    const scrollToClass = () => {
      setTimeout(() => {
        const className = route.query.className;
        if (className) {
          const dom = document.querySelector(`.${className}`);
          dom === null || dom === void 0 || dom.scrollIntoView();
        }
      }, 40);
    };
    const initSwiper = () => {
      new Swiper('.swiper-container', {
        // direction: 'vertical', // 垂直切换选项
        slidesPerView: 5,
        spaceBetween: 30,
        initialSlide: 10,
        centeredSlides: true,
        // loop: true,
        autoplay: {
          delay: 10000
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChange: swiper => {
            state.activeIndex = (swiper.activeIndex - 1 + 6) % 5;
            console.log(state.activeIndex);
          }
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aboutUs.text1')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('aboutUs.text2')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aboutUs.text3')), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('aboutUs.text4')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('aboutUs.text5')), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('aboutUs.text6')), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('aboutUs.text7')), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('aboutUs.text8')), 1)]), _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "company-banner",
        src: _imports_0
      }, null, -1))])]), _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"development-history\" data-v-28b50ce3><div class=\"development-history-title\" data-v-28b50ce3>发展历程</div><div class=\"development-history-title2\" data-v-28b50ce3>未来永无止境，我们砥砺前行</div><div class=\"swiper-container\" data-v-28b50ce3><div class=\"swiper-wrapper\" data-v-28b50ce3><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2011</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>5月优译信息公司成立</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2011</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2012</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>8月Transmate单机版发布</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2012</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2013</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>8月Transmate企业版发布</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>8月Transmate笔译教学系统发布</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2013</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2014</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月完成赛创种子融资</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2014</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2015</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>6月完成德尚天使轮融资</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>8月译马网上线</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2015</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2016</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>12月译马网稿件众包系统上线</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>12月份译马网译员认证体系上线</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>6月完成股改</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>3月图纸翻译等增值服务上线</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2016</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2017</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>7月入选腾讯AI加速器</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>10月译马网企业账户版上线</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>10月完成界石Pre-A轮融资</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2017</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2018</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月完成技转A+轮融资</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月完成百度A轮融资</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>8月入选百度AI加速器</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2018</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2019</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>4月投资译牛云同传</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>7月淘译员上线</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月译马网高校版上线</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>10月译马网机器翻译系统上线</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>12月通过ISO9001认证</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2019</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2020</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月被评为知识产权优势单位</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月被评为高新区瞪羚企业</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>8月通过ISO27001认证</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2020</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2021</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>1月被评为四川省专精特新企业</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>7月被评为3A级信用企业单位</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2021</div></div><div class=\"swiper-slide\" data-v-28b50ce3><div class=\"swiper-item2\" data-v-28b50ce3><div class=\"swiper-item-top\" data-v-28b50ce3><img src=\"" + _imports_1 + "\" class=\"qz-icon\" data-v-28b50ce3><div class=\"item-top-title\" data-v-28b50ce3>2022</div></div><div class=\"swiper-item-list\" data-v-28b50ce3><div class=\"swiper-item-yq\" data-v-28b50ce3></div><div class=\"item-list-text\" data-v-28b50ce3>9月通过ISO20000认证</div></div></div><div class=\"swiper-item\" data-v-28b50ce3>2022</div></div></div><img src=\"" + _imports_2 + "\" class=\"swiper-button-prev\" data-v-28b50ce3><img src=\"" + _imports_3 + "\" class=\"swiper-button-next\" data-v-28b50ce3></div></div>", 1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "data-statistics-title1"
      }, [_createElementVNode("span", null, "2500"), _createTextVNode(" + ")], -1)), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('aboutUs.text9')), 1)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "data-statistics-line"
      }, null, -1)), _createElementVNode("div", _hoisted_19, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "data-statistics-title1"
      }, [_createElementVNode("span", null, "9W"), _createTextVNode(" + ")], -1)), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('aboutUs.text10')), 1)]), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "data-statistics-line"
      }, null, -1)), _createElementVNode("div", _hoisted_21, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "data-statistics-title1"
      }, [_createElementVNode("span", null, "7"), _createTextVNode(" 项 ")], -1)), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('aboutUs.text11')), 1)]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "data-statistics-line"
      }, null, -1)), _createElementVNode("div", _hoisted_23, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "data-statistics-title1"
      }, [_createElementVNode("span", null, "6"), _createTextVNode(" 项 ")], -1)), _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('aboutUs.text12')), 1)]), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "data-statistics-line"
      }, null, -1)), _createElementVNode("div", _hoisted_25, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "data-statistics-title1"
      }, [_createElementVNode("span", null, "28"), _createTextVNode(" 项 ")], -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('aboutUs.text13')), 1)]), _cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "data-statistics-line"
      }, null, -1)), _createElementVNode("div", _hoisted_27, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "data-statistics-title1"
      }, [_createElementVNode("span", null, "36"), _createTextVNode(" 项 ")], -1)), _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('aboutUs.text14')), 1)])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('aboutUs.text15')), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('aboutUs.text16')), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[13] || (_cache[13] = _createElementVNode("img", {
        class: "yh-icon",
        src: _imports_4
      }, null, -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('aboutUs.text17')), 1), _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('aboutUs.text18')), 1)]), _cache[12] || (_cache[12] = _createElementVNode("img", {
        class: "card-right",
        src: _imports_5
      }, null, -1))])]), _createElementVNode("div", _hoisted_39, [_cache[15] || (_cache[15] = _createElementVNode("img", {
        class: "yh-icon",
        src: _imports_4
      }, null, -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('aboutUs.text19')), 1), _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('aboutUs.text20')), 1)]), _cache[14] || (_cache[14] = _createElementVNode("img", {
        class: "card-right",
        src: _imports_6
      }, null, -1))])]), _createElementVNode("div", _hoisted_44, [_cache[17] || (_cache[17] = _createElementVNode("img", {
        class: "yh-icon",
        src: _imports_4
      }, null, -1)), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('aboutUs.text21')), 1), _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('aboutUs.text22')), 1)]), _cache[16] || (_cache[16] = _createElementVNode("img", {
        class: "card-right",
        src: _imports_7
      }, null, -1))])])])])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('aboutUs.text23')), 1), _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('aboutUs.text24')), 1), _cache[18] || (_cache[18] = _createElementVNode("img", {
        class: "corporate-honors-zs",
        src: _imports_8
      }, null, -1))])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('aboutUs.text25')), 1), _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('aboutUs.text26')), 1), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_cache[19] || (_cache[19] = _createElementVNode("img", {
        src: _imports_9,
        class: "contac-item-icon"
      }, null, -1)), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('aboutUs.text27')), 1)]), _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('aboutUs.text28')) + "：", 1), _createElementVNode("div", _hoisted_62, [_createTextVNode(_toDisplayString(_ctx.$t('aboutUs.text29')) + "： ", 1), _cache[20] || (_cache[20] = _createElementVNode("span", {
        style: {
          "font-weight": "600",
          "font-family": "PingFang SC, PingFang SC-Semibold"
        }
      }, "199-8206-5680（张经理）、028-83316191", -1))])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_cache[21] || (_cache[21] = _createElementVNode("img", {
        src: _imports_10,
        class: "contac-item-icon"
      }, null, -1)), _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('aboutUs.text30')), 1)]), _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('aboutUs.text31')) + "：", 1), _createElementVNode("div", _hoisted_67, [_createTextVNode(_toDisplayString(_ctx.$t('aboutUs.text32')) + "： ", 1), _cache[22] || (_cache[22] = _createElementVNode("span", {
        style: {
          "font-weight": "600",
          "font-family": "PingFang SC, PingFang SC-Semibold"
        }
      }, "199-8206-5680（张经理） 、028-85599559", -1))])])]), _cache[23] || (_cache[23] = _createElementVNode("div", {
        id: "contact-map",
        class: "contact-us-map"
      }, null, -1))])])]);
    };
  }
});